import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { FormImageModel } from '@core/api';
import { BaseImageModel } from '@core/api';

import { UploadImageInterface } from './interfaces/upload-image.interface';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { of } from 'rxjs/internal/observable/of';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  private images$: BaseImageModel[] = [];
  public removeImageIds: number[] = [];

  constructor(private injector: Injector) { }

  get images(): BaseImageModel[] {
    return this.images$;
  }

  set images(value: BaseImageModel[]) {
    this.images$ = value;
  }

  upload<T>(service: UploadImageInterface<T>, resourceId: number): Observable<any> {

    const addObservers = this.images.map((image: BaseImageModel) => {

      const file = this.normalizeFile(image);

      if(image.id) {
        return service.edit(resourceId, image.id, file);
      }

      return service.upload(resourceId, file);
    });

    const removeObservers = this.removeImageIds.map(id => {
      return service.remove(resourceId, id);
    });

    this.removeImageIds = [];

    const observers = [...addObservers, ...removeObservers];

    if (observers.length) {
      return forkJoin(observers);
    } else {
      return of(true);
    }
  }

  private normalizeFile(image: BaseImageModel): FormImageModel {
    const file: FormImageModel = {
      description: image.description,
      main: image.main
    };

    if (image.file) {
      file.image = image.file;
    }

    return file;
  }
}
